import {RefObject, useEffect, useRef} from "react";

import {useFormContextRHF} from "@pg-design/rhf-components-module";
import {useUserDevice} from "@pg-mono/user-device";

import {usePinScrollParentToTop} from "@/hooks/use_pin_scroll_parent_to_top";
import {findScrollParent} from "@/utils/find_scroll_parent";
import {getOffsetInScrollParent} from "@/utils/get_offset_in_scroll_parent";

import {getHomeMatchPreferencesWizardLocationMapCoverStyle} from "../../utils/get_home_match_preferences_wizard_location_map_cover_style";
import {IHomeMatchPreferencesWizardSurveyForm} from "../../utils/get_home_match_preferences_wizard_step_patch";
import {useHomeMatchRegionSelection} from "../use_home_match_region_selection";

export interface IHomeMatchPreferencesWizardMapActions {
    apply: () => void;
    cancel: () => void;
}

interface IParams {
    isMapOpen: boolean;
    onMapActiveChange: (isMapActive: boolean) => void;
    onRegisterMapActions: (actions: IHomeMatchPreferencesWizardMapActions | null) => void;
    stepRef: RefObject<HTMLDivElement | null>;
}

// Location step map: open/apply/cancel, and on mobile the step slides up over the modal intro while the map is open.
export const useHomeMatchPreferencesWizardLocationMap = (params: IParams) => {
    const {isMapOpen, onMapActiveChange, onRegisterMapActions, stepRef} = params;
    const {isMobile} = useUserDevice();
    const {setValue, watch} = useFormContextRHF<IHomeMatchPreferencesWizardSurveyForm>();
    const regions = watch("regions");
    const coverOffsetRef = useRef(0);
    const {handleApply, handleCancel, handleUpdateRegionsByLocationPreview} = useHomeMatchRegionSelection({
        formValue: regions,
        handleFormUpdate: (nextRegions) => {
            setValue("regions", nextRegions, {shouldDirty: true});
        },
        initialFormValue: regions
    });

    usePinScrollParentToTop(stepRef, Boolean(isMobile && isMapOpen));

    const openMap = () => {
        if (isMapOpen) return;

        const step = stepRef.current;

        if (isMobile && step) {
            const scroller = findScrollParent(step);

            if (scroller) scroller.scrollTop = 0;

            coverOffsetRef.current = getOffsetInScrollParent(step);
        }

        onMapActiveChange(true);
    };

    const coverStyle = getHomeMatchPreferencesWizardLocationMapCoverStyle({isMapActive: isMapOpen, isMobile, offset: coverOffsetRef.current});
    const mapActionsRef = useRef<IHomeMatchPreferencesWizardMapActions>({apply: () => undefined, cancel: () => undefined});

    mapActionsRef.current = {
        apply: () => {
            handleApply();
            onMapActiveChange(false);
        },
        cancel: () => {
            handleCancel();
            onMapActiveChange(false);
        }
    };

    useEffect(() => {
        onRegisterMapActions({
            apply: () => mapActionsRef.current.apply(),
            cancel: () => mapActionsRef.current.cancel()
        });

        return () => onRegisterMapActions(null);
    }, [onRegisterMapActions]);

    return {coverStyle, handleUpdateRegionsByLocationPreview, openMap, regions};
};
import {RefObject, useEffect, useRef} from "react";

import {useFormContextRHF} from "@pg-design/rhf-components-module";
import {useUserDevice} from "@pg-mono/user-device";

import {usePinScrollParentToTop} from "@/hooks/use_pin_scroll_parent_to_top";
import {findScrollParent} from "@/utils/find_scroll_parent";
import {getOffsetInScrollParent} from "@/utils/get_offset_in_scroll_parent";

import {getHomeMatchPreferencesWizardLocationMapCoverStyle} from "../../utils/get_home_match_preferences_wizard_location_map_cover_style";
import {IHomeMatchPreferencesWizardSurveyForm} from "../../utils/get_home_match_preferences_wizard_step_patch";
import {useHomeMatchRegionSelection} from "../use_home_match_region_selection";

export interface IHomeMatchPreferencesWizardMapActions {
    apply: () => void;
    cancel: () => void;
}

interface IParams {
    isMapOpen: boolean;
    onMapActiveChange: (isMapActive: boolean) => void;
    onRegisterMapActions: (actions: IHomeMatchPreferencesWizardMapActions | null) => void;
    stepRef: RefObject<HTMLDivElement | null>;
}

// Location step map: open/apply/cancel, and on mobile the step slides up over the modal intro while the map is open.
export const useHomeMatchPreferencesWizardLocationMap = (params: IParams) => {
    const {isMapOpen, onMapActiveChange, onRegisterMapActions, stepRef} = params;
    const {isMobile} = useUserDevice();
    const {setValue, watch} = useFormContextRHF<IHomeMatchPreferencesWizardSurveyForm>();
    const regions = watch("regions");
    const coverOffsetRef = useRef(0);
    const {handleApply, handleCancel, handleUpdateRegionsByLocationPreview} = useHomeMatchRegionSelection({
        formValue: regions,
        handleFormUpdate: (nextRegions) => {
            setValue("regions", nextRegions, {shouldDirty: true});
        },
        initialFormValue: regions
    });

    usePinScrollParentToTop(stepRef, Boolean(isMobile && isMapOpen));

    const openMap = () => {
        if (isMapOpen) return;

        const step = stepRef.current;

        if (isMobile && step) {
            const scroller = findScrollParent(step);

            if (scroller) scroller.scrollTop = 0;

            coverOffsetRef.current = getOffsetInScrollParent(step);
        }

        onMapActiveChange(true);
    };

    const coverStyle = getHomeMatchPreferencesWizardLocationMapCoverStyle({isMapActive: isMapOpen, isMobile, offset: coverOffsetRef.current});
    const mapActionsRef = useRef<IHomeMatchPreferencesWizardMapActions>({apply: () => undefined, cancel: () => undefined});

    mapActionsRef.current = {
        apply: () => {
            handleApply();
            onMapActiveChange(false);
        },
        cancel: () => {
            handleCancel();
            onMapActiveChange(false);
        }
    };

    useEffect(() => {
        onRegisterMapActions({
            apply: () => mapActionsRef.current.apply(),
            cancel: () => mapActionsRef.current.cancel()
        });

        return () => onRegisterMapActions(null);
    }, [onRegisterMapActions]);

    return {coverStyle, handleUpdateRegionsByLocationPreview, openMap, regions};
};
